window.theme = window.theme || {};

  (function(){
    'use strict';
  
    theme.delegate = {
      on: function(event, callback, options){
        if( !this.namespaces ) // save the namespaces on the DOM element itself
          this.namespaces = {};
    
        this.namespaces[event] = callback;
        options = options || false;
    
        this.addEventListener(event.split('.')[0], callback, options);
        return this;
      },
      off: function(event) {
        if (!this.namespaces) { return }
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
      }
    };

    // Extend the DOM with these above custom methods
    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    function formatMoneyWithoutTrailingZeros(cents) {
      return theme.Currency.formatMoney(cents, getThemeMoneyFormatRaw())
        .replace(/\.00$/, '');
    }

    /**
     * Format cents with decimals always shown (e.g., 11115 -> "$111.15").
     * Uses a forced ${{amount}} format to bypass the store's money_format,
     * which may use amount_no_decimals and hide real cents.
     */
    function formatMoneyWithCents(cents) {
      return theme.Currency.formatMoney(cents, '${{amount}}');
    }

    /**
     * Correct cart line item prices using raw cents from data attributes.
     * This ensures prices with real cents (e.g., market-adjusted prices)
     * display accurately, regardless of the store's money_format setting.
     * Called synchronously after cart HTML is inserted to avoid visible flash.
     */
    function correctLineItemPrices(container) {
      if (!container) return;
      container.querySelectorAll('.cart__item-price-col').forEach(function(col) {
        var originalCents = col.getAttribute('data-original-price-cents');
        var finalCents = col.getAttribute('data-final-price-cents');
        if (!originalCents) return;

        var formattedOriginal = formatMoneyWithCents(parseInt(originalCents, 10));
        var formattedFinal = finalCents ? formatMoneyWithCents(parseInt(finalCents, 10)) : formattedOriginal;

        // Update the displayed price elements
        var priceEl = col.querySelector('.cart__price:not(.cart__price--strikethrough):not(.cart__discount)');
        var discountEl = col.querySelector('.cart__price.cart__discount');
        var strikethroughEl = col.querySelector('.cart__price.cart__price--strikethrough');

        if (discountEl && strikethroughEl) {
          // Discounted item: update both sale and original prices
          discountEl.textContent = formattedFinal;
          strikethroughEl.textContent = formattedOriginal;
        } else if (priceEl) {
          // Regular item: update the single price
          priceEl.textContent = formattedOriginal;
        }
      });
    }

    function getThemeMoneyFormatRaw() {
      if (theme && typeof theme.moneyFormat === 'string' && theme.moneyFormat.length) {
        return theme.moneyFormat;
      }

      if (theme && theme.settings && typeof theme.settings.moneyFormat === 'string' && theme.settings.moneyFormat.length) {
        return theme.settings.moneyFormat;
      }

      return '${{amount}}';
    }

    theme.Currency = (function() {
        var moneyFormat = '${{amount}}';
        var superScript = theme && theme.settings && theme.settings.superScriptPrice;
      
        function formatMoney(cents, format) {
          if (!format) {
            format = getThemeMoneyFormatRaw();
          }
      
          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || moneyFormat);
      
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = theme.utils.defaultTo(precision, 2);
            thousands = theme.utils.defaultTo(thousands, ',');
            decimal = theme.utils.defaultTo(decimal, '.');
      
            if (isNaN(number) || number == null) {
              return 0;
            }
      
            number = (number / 100.0).toFixed(precision);
      
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
            return dollarsAmount + centsAmount;
          }
      
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
      
              if (superScript && value && value.includes('.')) {
                value = value.replace('.', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
      
              if (superScript && value && value.includes(',')) {
                value = value.replace(',', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          }
      
          return formatString.replace(placeholderRegex, value);
        }
      
        function getBaseUnit(variant) {
          if (!variant) {
            return;
          }
      
          if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
            return;
          }
      
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }
      
        return {
          formatMoney: formatMoney,
          getBaseUnit: getBaseUnit
        }
    })();

    theme.utils = {
        defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
        },
    
        wrap: function(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        },
    
        debounce: function(wait, callback, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
            timeout = null;
            if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
        }
        },
    
        throttle: function(limit, callback) {
        var waiting = false;
        return function () {
            if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(function () {
                waiting = false;
            }, limit);
            }
        }
        },
    
        prepareTransition: function(el, callback) {
        el.addEventListener('transitionend', removeClass);
    
        function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
        }
    
        el.classList.add('is-transitioning');
        el.offsetWidth; // check offsetWidth to force the style rendering
    
        if (typeof callback === 'function') {
            callback();
        }
        },
    
        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
    
        while (++index < length) {
            var value = array[index];
            if (value) {
            result[resIndex++] = value;
            }
        }
        return result;
        },
    
        serialize: function(form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function(field) {
            if (
            !field.name ||
            field.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
            return;
            if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;
                arr.push(
                encodeURIComponent(field.name) +
                    '=' +
                    encodeURIComponent(option.value)
                );
            });
            return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
            return;
            arr.push(
            encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
        });
        return arr.join('&');
        }
    };

    theme.a11y = {
        trapFocus: function(options) {
          var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace
              ? 'focusout.' + options.namespace
              : 'focusout',
            keydown: options.namespace
              ? 'keydown.' + options.namespace
              : 'keydown.handleFocus'
          };
      
          // Get every possible visible focusable element
          var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
          var elArray = [].slice.call(focusableEls);
          var focusableElements = elArray.filter(el => el.offsetParent !== null);
      
          var firstFocusable = focusableElements[0];
          var lastFocusable = focusableElements[focusableElements.length - 1];
      
          if (!options.elementToFocus) {
            options.elementToFocus = options.container;
          }
      
          options.container.setAttribute('tabindex', '-1');
          options.elementToFocus.focus();
      
          document.documentElement.off('focusin');
          document.documentElement.on(eventsName.focusout, function() {
            document.documentElement.off(eventsName.keydown);
          });
      
          document.documentElement.on(eventsName.focusin, function(evt) {
            if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
      
            document.documentElement.on(eventsName.keydown, function(evt) {
              _manageFocus(evt);
            });
          });
      
          function _manageFocus(evt) {
            if (evt.keyCode !== 9) return;
            /**
             * On the first focusable element and tab backward,
             * focus the last element
             */
            if (evt.target === lastFocusable && !evt.shiftKey) {
              evt.preventDefault();
              firstFocusable.focus();
            }
          }
        },
        removeTrapFocus: function(options) {
          var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';
      
          if (options.container) {
            options.container.removeAttribute('tabindex');
          }
      
          document.documentElement.off(eventName);
        },
      
        lockMobileScrolling: function(namespace, element) {
          document.documentElement.classList.add('lock-scroll');
          document.body.classList.add('lock-scroll');

          var el = element ? element : document.documentElement;
          if (!el || !el.on) {
            return;
          }

          el.on('touchmove' + namespace, function() {
            return true;
          });
        },
      
        unlockMobileScrolling: function(namespace, element) {
          document.documentElement.classList.remove('lock-scroll');
          document.body.classList.remove('lock-scroll');

          var el = element ? element : document.documentElement;
          if (el && el.off) {
            el.off('touchmove' + namespace);
          }

          if (el !== document.documentElement && document.documentElement.off) {
            document.documentElement.off('touchmove' + namespace);
          }
        }
    };

    theme.Drawers = (function() {
        function Drawers(id, name) {
        this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            // Keep cart drawer isolated from legacy global drawer overlays/classes.
            openClass: 'is-cart-drawer-open',
            closingClass: 'is-cart-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
        };
    
        this.nodes = {
            page: document.querySelector('#MainContent')
        };
    
        this.drawer = document.querySelector('#' + id);
        this.backdrop = document.querySelector('#' + id + 'Backdrop');
        this.isOpen = false;
        this.handleWindowClick = this.close.bind(this);
        this.handleWindowKeyup = function(evt) {
            if (evt.keyCode === 27 || evt.key === 'Escape') {
            this.close();
            }
        }.bind(this);
    
        if (!this.drawer) {
            return;
        }
    
        this.init();
        }
    
        Drawers.prototype = Object.assign({}, Drawers.prototype, {
        init: function() {
            // Setup open button(s)
            document.querySelectorAll(this.config.open).forEach(openBtn => {
            openBtn.setAttribute('aria-expanded', 'false');
            openBtn.addEventListener('click', this.open.bind(this));
            });

            this.drawer.querySelectorAll(this.config.close).forEach(function(closeBtn) {
            closeBtn.addEventListener('click', this.close.bind(this));
            }.bind(this));

            if (this.backdrop) {
            this.backdrop.addEventListener('click', this.close.bind(this));
            }
            this.handleDrawerLinkClick = this._onDrawerLinkClick.bind(this);
            this.handlePageHide = this._clearLockState.bind(this, true);
            window.addEventListener('pagehide', this.handlePageHide);

            // Close modal if a drawer is opened
            document.addEventListener('modalOpen', function() {
            this.close();
            }.bind(this));
        },
    
        open: function(evt, returnFocusEl) {
            if (evt) {
            evt.preventDefault();
            }
    
            if (this.isOpen) {
            return;
            }
    
            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            evt.currentTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = evt.currentTarget;
            } else if (returnFocusEl) {
            returnFocusEl.setAttribute('aria-expanded', 'true');
            this.activeSource = returnFocusEl;
            }
    
            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.add(this.config.activeDrawer);
            }.bind(this));
    
            document.documentElement.classList.add(this.config.openClass);
            if (this.backdrop) {
            this.backdrop.setAttribute('aria-hidden', 'false');
            }
            this.isOpen = true;
    
            theme.a11y.trapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });
    
            document.dispatchEvent(new CustomEvent('drawerOpen'));
            document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
    
            this.bindEvents();
        },
    
        close: function(evt) {
            if (!this.isOpen) {
            this._clearLockState(true);
            return;
            }
    
            // Do not close if click event came from inside drawer
            if (evt) {
            var target = evt.target;
            if (target && target.closest && target.closest('.js-drawer-close')) {
                // Do not close if using the drawer close button
            } else if (target && target.closest && target.closest('.drawer')) {
                return;
            }
            }
    
            // deselect any focused form elements
            document.activeElement.blur();
    
            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.remove(this.config.activeDrawer);
            }.bind(this));
    
            document.documentElement.classList.remove(this.config.openClass);
            document.documentElement.classList.add(this.config.closingClass);
            if (this.backdrop) {
            this.backdrop.setAttribute('aria-hidden', 'true');
            }
    
            window.setTimeout(function() {
            document.documentElement.classList.remove(this.config.closingClass);
            if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
                this.activeSource.setAttribute('aria-expanded', 'false');
                this.activeSource.focus();
            }
            this._clearLockState(false);
            }.bind(this), 500);
    
            this.isOpen = false;
    
            theme.a11y.removeTrapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });
    
            this.unbindEvents();

            // Defensive cleanup in case third-party scripts leave lock styles/classes.
            this._clearLockState(false);
        },

        _onDrawerLinkClick: function(evt) {
            var link = evt.target && evt.target.closest ? evt.target.closest('a[href]') : null;
            if (!link || !this.drawer.contains(link)) {
            return;
            }

            if (link.closest && link.closest('[js-upsell-slider]')) {
            return;
            }

            if (link.closest && link.closest('[data-afterpay-widget], .afterpay-paragraph, .c-afterpay-info-modal')) {
            return;
            }

            if (link.closest && link.closest('[data-onward-widget], .nvd-mini, #nvdMini, #nvd-widget-cart')) {
            return;
            }

            if (link.classList.contains('js-cart-remove')) {
            return;
            }

            var href = link.getAttribute('href');
            if (!href || href === '#' || href.indexOf('javascript:') === 0) {
            return;
            }

            // Don't close the drawer for checkout links — let the page navigate directly
            if (href.indexOf('/checkout') === 0) {
            return;
            }

            this.close();
        },

        _clearLockState: function(removeDrawerStateClasses) {
            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);

            var root = document.documentElement;
            var body = document.body;
            var sharedClasses = [
              'lock-scroll',
              'is-cart-drawer-open',
              'is-cart-drawer-closing',
              // Defensive legacy cleanup to prevent stuck page locks.
              'js-drawer-open',
              'js-drawer-closing',
              'cart-open'
            ];

            [root, body].forEach(function(node) {
            if (!node) {
                return;
            }

            sharedClasses.forEach(function(className) {
                node.classList.remove(className);
            });
            });

            if (removeDrawerStateClasses) {
            [root, body].forEach(function(node) {
                if (!node) {
                return;
                }

                node.classList.remove(this.config.openClass);
                node.classList.remove(this.config.closingClass);
            }.bind(this));
            }

            [root, body].forEach(function(node) {
            if (!node) {
                return;
            }

            ['overflow', 'position', 'top', 'left', 'right', 'width'].forEach(function(prop) {
                node.style.removeProperty(prop);
            });
            });
        },

        bindEvents: function() {
            // Clicking out of drawer closes it
            window.addEventListener('click', this.handleWindowClick);
            window.addEventListener('keyup', this.handleWindowKeyup);

            this.drawer.addEventListener('click', this.handleDrawerLinkClick, true);

            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
        },

        unbindEvents: function() {
            window.removeEventListener('click', this.handleWindowClick);
            window.removeEventListener('keyup', this.handleWindowKeyup);
            this.drawer.removeEventListener('click', this.handleDrawerLinkClick, true);

            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
        }
        });
    
        return Drawers;
    })();

    theme.CartDrawer = (function() {
        var selectors = {
        drawer: '#CartDrawer',
        form: '#CartDrawerForm'
        };
    
        function CartDrawer() {
        this.form = document.querySelector(selectors.form);
        this.drawer = new theme.Drawers('CartDrawer', 'cart');
    
        this.init();
        }
    
        CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
        init: function() {
            this.cartForm = new theme.CartForm(this.form);
            this.cartForm.buildCart();
    
            document.addEventListener('ajaxProduct:added', function(evt) {
            this.cartForm.buildCart();
            this.open();
            }.bind(this));
    
            // Dev-friendly way to open cart
            document.addEventListener('cart:open', this.open.bind(this));
            document.addEventListener('cart:close', this.close.bind(this));
        },
    
         open: function() {
            this.drawer.open();
    
            theme.a11y.trapFocus({
            container: this.form,
            elementToFocus: this.form,
            namespace: 'cartdrawer_focus'
            });
         },
    
        close: function() {
            this.drawer.close();
    
            theme.a11y.removeTrapFocus({
            container: this.form,
            namespace: 'cartdrawer_focus'
            });
        }
        });
    
        return CartDrawer;
    })();

    theme.cart = {
        getCart: function() {
          var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(response => response.json());
        },
      
        getCartProductMarkup: function() {
          var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
      
          url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(response => response.text())
          .catch(e => console.error(e));
        },
      
        changeItem: function(key, qty) {
      
          return this._updateCart({
            url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
            data: JSON.stringify({
              id: key,
              quantity: qty
            })
          })
        },
      
        _updateCart: function(params) {
          return fetch(params.url, {
            method: 'POST',
            body: params.data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          })
          .then(response => { return response.text() })
          .then(cart => { return cart; });
        },
      
        updateAttribute: function(key, value) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              attributes: {
                [key]: theme.cart.attributeToString(value)
              }
            })
          });
        },
      
        updateNote: function(note) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              note: theme.cart.attributeToString(note)
            })
          });
        },
      
        attributeToString: function(attribute) {
          if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
              attribute = '';
            }
          }
          return attribute.trim();
        }
    };

    var afterpayScriptPromise = null;
    var enableLiveAfterpayWidget = false; // Disabled: using modern square-placement widget via Afterpay app instead

    function waitForAfterpay(resolve, reject) {
      var attempts = 0;
      var maxAttempts = 30;

      var timer = window.setInterval(function() {
        attempts += 1;

        if (typeof window.presentAfterpay === 'function') {
          window.clearInterval(timer);
          resolve(window.presentAfterpay);
          return;
        }

        if (attempts >= maxAttempts) {
          window.clearInterval(timer);
          afterpayScriptPromise = null;
          reject(new Error('Afterpay did not initialize in time'));
        }
      }, 100);
    }

    function loadAfterpayScript() {
      if (typeof window.presentAfterpay === 'function') {
        return Promise.resolve(window.presentAfterpay);
      }

      if (afterpayScriptPromise) {
        return afterpayScriptPromise;
      }

      afterpayScriptPromise = new Promise(function(resolve, reject) {
        var existingScript = document.querySelector('script[src*="static-us.afterpay.com/javascript/present-afterpay.js"]');

        if (existingScript) {
          waitForAfterpay(resolve, reject);
          return;
        }

        var script = document.createElement('script');
        script.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
        script.async = true;
        script.onload = function() {
          waitForAfterpay(resolve, reject);
        };
        script.onerror = function() {
          afterpayScriptPromise = null;
          reject(new Error('Failed to load Afterpay script'));
        };

        document.head.appendChild(script);
      });

      return afterpayScriptPromise;
    }

    theme.CartForm = (function() {
        var selectors = {
        products: '[data-products]',
        progressBar: '[js-progress-bar]',
        cartUpsell: '[js-cart-upsell]',
        qtySelector: '.js-qty__wrapper',
        removeSelector: '.js-cart-remove',
        purchaseSelect: '.js-purchase-select',
        upgradeBtn: '.js-upgrade-btn',
        discounts: '[data-discounts]',
        savings: '[data-savings]',
        subTotal: '[data-subtotal]',
        afterpayWidget: '[data-afterpay-widget]',
        afterpayPriceSource: '[data-afterpay-price-source]',
        afterpayCopy: '[data-afterpay-copy]',
    
        cartBubble: '.cart-link__bubble',
        checkoutBtn: '.cart__checkout'
        };
    
        var classes = {
        btnLoading: 'btn--loading'
        };
    
        var config = {
        requiresTerms: false
        };
    
        function CartForm(form) {
        if (!form) {
            return;
        }
    
        this.form = form;
        this.wrapper = form.parentNode;
        this.location = form.dataset.location;
        this.namespace = '.cart-' + this.location;
        this.products = form.querySelector(selectors.products);
        this.progressBar = form.querySelector(selectors.progressBar);
        this.cartUpsell = form.querySelector(selectors.cartUpsell);
        this.cartNonEmptyUpsell = form.querySelector(selectors.cartNonEmptyUpsell);
        this.submitBtn = form.querySelector(selectors.checkoutBtn);
    
        this.discounts = form.querySelector(selectors.discounts);
        this.savings = form.querySelector(selectors.savings);
        this.subtotal = form.querySelector(selectors.subTotal);
        this.afterpayWidget = form.querySelector(selectors.afterpayWidget);
        this.afterpayPriceSource = form.querySelector(selectors.afterpayPriceSource);
        this.afterpayCopy = form.querySelector(selectors.afterpayCopy);
        this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
        this.noteInput = form.querySelector(selectors.cartNote);
        this.afterpayAmountCents = null;

        if (this.afterpayPriceSource && !this.afterpayPriceSource.id) {
          this.afterpayPriceSource.id = 'afterpay-price-source-' + this.location;
        }
    
        this.cartItemsUpdated = false;
    
        if (this.termsCheckbox) {
            config.requiresTerms = true;
        }
    
        this.init();
        }
    
        CartForm.prototype = Object.assign({}, CartForm.prototype, {
        init: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
            this.syncLegacyWidgetsDebounced = theme.utils.debounce(250, this.syncLegacyWidgets.bind(this));
            this.syncLegacyWidgets();
    
            document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

            this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
    
            if (this.noteInput) {
            this.noteInput.addEventListener('change', function() {
                var newNote = this.value;
                theme.cart.updateNote(newNote);
            });
            }
    
            // Dev-friendly way to build the cart
            document.addEventListener('cart:build', function() {
            this.buildCart();
            }.bind(this));
        },

        reInit: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
        },
    
        onSubmit: function(evt) {
            this.submitBtn.classList.add(classes.btnLoading);
    
            /*
            Checks for drawer or cart open class on body element
            and then stops the form from being submitted. We are also
            checking against a custom property, this.cartItemsUpdated = false.
    
            Error is handled in the quantityChanged method
    
            For Expanse/Fetch/Gem quick add, if an error is present it is alerted
            through the add to cart fetch request in quick-add.js.
    
            Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
            Expanse/Fetch/Gem when using quick add
            */
    
            if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
            document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
            }
    
            if (config.requiresTerms) {
            if (this.termsCheckbox.checked) {
                // continue to checkout
            } else {
                alert(theme.strings.cartTermsConfirmation);
                this.submitBtn.classList.remove(classes.btnLoading)
                evt.preventDefault();
                return false;
            }
            }
        },
    
        /*============================================================================
            Query cart page to get markup
        ==============================================================================*/
        _parseProductHTML: function(text) {
            const html = document.createElement('div');
            html.innerHTML = text;
    
            return {
                items: html.querySelector('.cart__items'),
                discounts: html.querySelector('.cart__discounts'),
                progressBar: html.querySelector("[js-progress-bar]"),
                cartUpsell: html.querySelector("[js-cart-upsell]")
            }
        },
    
        buildCart: function() {
            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
        },
    
        cartMarkup: function(text) {
            var markup = this._parseProductHTML(text);
            var items = markup.items;
            var progressBar = markup.progressBar;
            var cartUpsell = markup.cartUpsell;
            if (!items) {
              return;
            }
            var count = parseInt(items.dataset.count);
            var subtotal = parseInt(items.dataset.cartSubtotal, 10) || 0;
            var savings = items.dataset.cartSavings;
    
            this.updateCartDiscounts(markup.discounts);
            this.updateSavings(savings);
    
            if (count > 0) {
            this.wrapper.classList.remove('is-empty');
            } else {
            this.wrapper.classList.add('is-empty');
            }
    
            this.updateCount(count);

            // progressBar markup
            if(this.progressBar) {
                this.progressBar.innerHTML = progressBar.innerHTML;
            }

            // If item keys/order are unchanged, keep existing row DOM to prevent quantity-update flicker.
            var incomingRows = Array.from(items.querySelectorAll('.cart__item[data-key]'));
            var currentRows = this.products
              ? Array.from(this.products.querySelectorAll('.cart__item[data-key]'))
              : [];
            var currentRowsByKey = {};
            currentRows.forEach(function(row) {
              currentRowsByKey[row.dataset.key] = row;
            });
            var incomingKeys = incomingRows.map(function(row) { return row.dataset.key; });
            var currentKeys = currentRows.map(function(row) { return row.dataset.key; });
            var sameRowStructure =
              incomingKeys.length === currentKeys.length &&
              incomingKeys.every(function(key, index) { return key === currentKeys[index]; });

            var itemsChanged = false;

            if (!sameRowStructure) {
              var incomingItemsMarkup = (items && items.innerHTML) ? items.innerHTML.trim() : '';
              var currentItemsMarkup = this.products ? this.products.innerHTML.trim() : '';
              itemsChanged = incomingItemsMarkup !== currentItemsMarkup;

              if (this.products && itemsChanged) {
                this.products.innerHTML = incomingItemsMarkup;
              }
            } else {
              // Keep stable row DOM to avoid flicker, but sync live quantity values.
              incomingRows.forEach(function(incomingRow) {
                var currentRow = currentRowsByKey[incomingRow.dataset.key];
                if (!currentRow) {
                  return;
                }

                var incomingQtyInput = incomingRow.querySelector('.js-qty__num');
                var currentQtyInput = currentRow.querySelector('.js-qty__num');

                if (incomingQtyInput && currentQtyInput && currentQtyInput.value !== incomingQtyInput.value) {
                  currentQtyInput.value = incomingQtyInput.value;
                }
              });
            }

            // Correct line item prices using raw cents to bypass amount_no_decimals rounding
            correctLineItemPrices(this.products);

            // Build upsell markup and re-init slider whenever this section is refreshed.
            var upsellUpdated = false;
            if (this.cartUpsell && cartUpsell) {
              this.cartUpsell.innerHTML = cartUpsell.innerHTML;
              upsellUpdated = true;
            }
    
            // Update Checkout+ total and companion footer values.
            this.updateCheckoutSummary(subtotal);
    
            if (itemsChanged) {
              this.reInit();
            }

            if (upsellUpdated) {
              document.dispatchEvent(new CustomEvent('cart-upsell:init'));
            }
       
    
            if (window.AOS) { AOS.refreshHard() }
    
            if (Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
            }
        },
    
        updateCartDiscounts: function(markup) {
            if (!this.discounts) {
            return;
            }
            this.discounts.innerHTML = '';
            this.discounts.append(markup);
        },
    
        /*============================================================================
            Quantity handling
        ==============================================================================*/
        initQtySelectors: function() {
            this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
            var selector = new theme.QtySelector(el, {
                namespace: this.namespace,
                isCart: true
            });
            });
        },

        /*============================================================================
            Cart remove handling
        ==============================================================================*/
        initRemoveSelectors: function() {
            this.form.querySelectorAll(selectors.removeSelector).forEach(el => {
            new theme.RemoveSelector(el);
            });
        },

        /*============================================================================
            Cart purchase handling
        ==============================================================================*/
        initUpdatePurchase: function() {
            if(this.form.querySelectorAll(selectors.upgradeBtn)) {
            this.form.querySelectorAll(selectors.upgradeBtn).forEach(el => {
                new theme.UpdatePurchase(el);
            });
            }
        },

        initPurchaseSelectors: function() {
            if(this.form.querySelectorAll(selectors.purchaseSelect)) {
            this.form.querySelectorAll(selectors.purchaseSelect).forEach(el => {
                new theme.PurchaseSelector(el);
            });
            }
        },
    
        quantityChanged: function(evt) {
            var key = evt.detail[0];
            var qty = evt.detail[1];
            var el = evt.detail[2];
    
            if (!key || !qty) {
            return;
            }
    
            // Disable qty selector so multiple clicks can't happen while loading
            if (el) {
            el.classList.add('is-loading');
            }
    
            theme.cart.changeItem(key, qty)
            .then(function(cart) {
    
                const parsedCart = JSON.parse(cart);

                if (parsedCart.status === 422) {
                alert(parsedCart.message);
                } else {
                // Update cart bubbles immediately from Shopify response so count feels instant.
                if (typeof parsedCart.item_count === 'number') {
                    this.updateCount(parsedCart.item_count);
                }

                const updatedItem = parsedCart.items.find(item => item.key === key);
    
                // Update cartItemsUpdated property on object so we can reference later
                if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                    this.cartItemsUpdated = true;
                    var row = this.form.querySelector('.cart__item[data-key="' + key + '"]');
                    var qtyInput = row ? row.querySelector('.js-qty__num') : null;
                    if (qtyInput) {
                      qtyInput.value = updatedItem.quantity;
                    }
                }
    
                if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                    if (updatedItem.quantity !== qty) {
                    }
                    // Reset property on object so that checkout button will work as usual
                    this.cartItemsUpdated = false;
                }
    
                if (parsedCart.item_count > 0) {
                    this.wrapper.classList.remove('is-empty');
                } else {
                    this.wrapper.classList.add('is-empty');
                }
                }

                this.buildCart();
                this.syncLegacyWidgets(parsedCart);

                document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: parsedCart
                }
                }));
            }.bind(this))
            .catch(function(XMLHttpRequest){});
        },

        notifyLegacyCartHooks: function(cart) {
            if (window.jQuery && window.jQuery.fn && window.jQuery('body').length) {
                window.jQuery('body').trigger('ajaxCart.afterCartLoad', cart || null);
            }
        },

        syncLegacyWidgets: function(cart) {
            if (cart) {
                this.notifyLegacyCartHooks(cart);
                return;
            }

            theme.cart.getCart()
                .then(function(liveCart) {
                    this.notifyLegacyCartHooks(liveCart);
                }.bind(this))
                .catch(function() {
                    this.notifyLegacyCartHooks(null);
                }.bind(this));
        },

        /*============================================================================
            Update elements of the cart
        ==============================================================================*/
        updateSubtotal: function(subtotal) {
            this.form.querySelector(selectors.subTotal).innerHTML = formatMoneyWithoutTrailingZeros(subtotal);
        },

        getOnwardProtectionCents: function() {
            try {
                var optedOut = localStorage.getItem('nvd_opted_out');
                if (optedOut === 'true') {
                    return 0;
                }

                var raw = localStorage.getItem('nvdProtectionPrice');
                var amount = parseFloat(raw);
                if (!isFinite(amount) || amount <= 0) {
                    return 0;
                }

                return Math.round(amount * 100);
            } catch (err) {
                return 0;
            }
        },

        updateCheckoutSummary: function(subtotalCents) {
            var onwardProtectionCents = this.getOnwardProtectionCents();
            var checkoutPlusTotalCents = subtotalCents + onwardProtectionCents;

            if (this.syncLegacyWidgetsDebounced) {
                this.syncLegacyWidgetsDebounced();
            }

            if (this.subtotal) {
                this.subtotal.innerHTML = formatMoneyWithoutTrailingZeros(checkoutPlusTotalCents);
            }

            this.updateAfterpayCopy(checkoutPlusTotalCents);
        },

        updateAfterpayCopy: function(checkoutPlusTotalCents) {
            // Update modern square-placement widget amount
            var squarePlacement = this.form ? this.form.querySelector('square-placement') : null;
            if (squarePlacement) {
                squarePlacement.setAttribute('data-amount', theme.Currency.formatMoney(checkoutPlusTotalCents || 0, getThemeMoneyFormatRaw()));
            }

            if (!this.afterpayCopy) {
                return;
            }

            if (!checkoutPlusTotalCents || checkoutPlusTotalCents <= 0) {
                this.afterpayCopy.innerHTML = '';
                this.afterpayCopy.style.display = '';
                this.teardownAfterpayWidget();
                return;
            }

            var installmentCents = Math.round(checkoutPlusTotalCents / 4);
            var installment = theme.Currency.formatMoney(installmentCents, getThemeMoneyFormatRaw());

            this.afterpayCopy.innerHTML = 'or as low as ' + installment + '/mo. with Afterpay';
            this.afterpayCopy.style.display = '';

            if (enableLiveAfterpayWidget) {
                this.mountAfterpayWidget(checkoutPlusTotalCents);
            } else {
                this.teardownAfterpayWidget();
            }
        },

        mountAfterpayWidget: function(checkoutPlusTotalCents) {
            if (!this.afterpayWidget || !this.afterpayPriceSource) {
                return;
            }

            if (window.currencyIso && window.currencyIso !== 'USD') {
                return;
            }

            var amount = parseInt(checkoutPlusTotalCents, 10) || 0;
            if (amount <= 0) {
                this.teardownAfterpayWidget();
                return;
            }

            if (
                this.afterpayAmountCents === amount &&
                this.afterpayWidget.querySelector('.afterpay-paragraph')
            ) {
                if (this.afterpayCopy) {
                    this.afterpayCopy.style.display = 'none';
                }
                return;
            }

            this.afterpayAmountCents = amount;
            this.afterpayPriceSource.innerHTML = theme.Currency.formatMoney(amount, getThemeMoneyFormatRaw());

            loadAfterpayScript()
                .then(function() {
                    if (typeof window.presentAfterpay !== 'function') {
                        return;
                    }

                    this.teardownAfterpayWidget();

                    var config = {
                        afterpayLogoColor: 'color',
                        priceSelector: '#' + this.afterpayPriceSource.id,
                        locale: 'en_US',
                        amount: amount,
                        showUpperLimit: false,
                        minMaxThreshold: { min: 100, max: 100000000 },
                        giftCard: false,
                        mutationObserver: { activated: false, isDecimalPrice: true }
                    };

                    new window.presentAfterpay(config).init();

                    window.setTimeout(function() {
                        if (this.afterpayWidget.querySelector('.afterpay-paragraph') && this.afterpayCopy) {
                            this.afterpayCopy.style.display = 'none';
                        }
                    }.bind(this), 0);
                }.bind(this))
                .catch(function() {
                    if (this.afterpayCopy) {
                        this.afterpayCopy.style.display = '';
                    }
                }.bind(this));
        },

        teardownAfterpayWidget: function() {
            if (!this.afterpayWidget) {
                return;
            }

            this.afterpayWidget.querySelectorAll('.afterpay-paragraph').forEach(function(node) {
                if (node && node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            });
        },
    
        updateSavings: function(savings) {
            if (!this.savings) {
            return;
            }
    
            if (savings > 0) {
            var amount = theme.Currency.formatMoney(savings, getThemeMoneyFormatRaw());
            this.savings.classList.remove('hide');
            this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
            } else {
            this.savings.classList.add('hide');
            }
        },
    
        updateCount: function(count) {
            var countEls = document.querySelectorAll('.cart-link__bubble-num');
    
            if (countEls.length) {
            countEls.forEach(el => {
                el.innerText = count;
            });
            }
    
            // show/hide bubble(s)
            var bubbles = document.querySelectorAll(selectors.cartBubble);
            if (bubbles.length) {
            if (count > 0) {
                bubbles.forEach(b => {
                b.classList.add('cart-link__bubble--visible');
                });
            } else {
                bubbles.forEach(b => {
                b.classList.remove('cart-link__bubble--visible');
                });
            }
            }
        }
        });
    
        return CartForm;
    })();

    theme.QtySelector = (function() {
        var selectors = {
        input: '.js-qty__num',
        plus: '.js-qty__adjust--plus',
        minus: '.js-qty__adjust--minus'
        };
    
        function QtySelector(el, options) {
        this.wrapper = el;
        this.plus = el.querySelector(selectors.plus);
        this.minus = el.querySelector(selectors.minus);
        this.input = el.querySelector(selectors.input);
        this.minValue = this.input.getAttribute('min') || 1;
    
        var defaults = {
            namespace: null,
            isCart: false,
            key: this.input.dataset.id
        };
    
        this.options = Object.assign({}, defaults, options);
    
        this.init();
        }
    
        QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
        init: function() {
            this.plus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty + 1);
            }.bind(this));
    
            this.minus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty - 1);
            }.bind(this));
    
            this.input.addEventListener('change', function(evt) {
            this._change(this._getQty());
            }.bind(this));
        },
    
        _getQty: function() {
            var qty = this.input.value;
            if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
            } else {
            // Not a number. Default to 1.
            qty = 1;
            }
            return parseInt(qty);
        },
    
        _change: function(qty) {
            if (qty <= this.minValue) {
            qty = this.minValue;
            }
    
            this.input.value = qty;
    
            if (this.options.isCart) {
            document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
                detail: [this.options.key, qty, this.wrapper]
            }));
            }
        }
        });
    
        return QtySelector;
    })();

    theme.RemoveSelector = (function() {
        function cartRemoveSelector(el) {
          this.removeBtn = el;
          this.init();
        }
      
        cartRemoveSelector.prototype = Object.assign({}, cartRemoveSelector.prototype, {
          init: function() {
            this.removeBtn.addEventListener('click', function(e) {
              e.preventDefault();

              const url = this.removeBtn.getAttribute("href");
              this.removeBtn.classList.add("btn--loading");

              this._updateCart(url);
            }.bind(this));
          },
      
          _updateCart: function(url) {
            // Extract the item key from the URL and use the JSON API
            // so the response is fully consumed before rebuilding the cart.
            var urlParams = new URL(url, window.location.origin).searchParams;
            var itemId = urlParams.get('id');

            fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ id: itemId, quantity: 0 })
            })
            .then(response => response.json())
            .then(data => {
              this._updateCount(data);
              this.removeBtn.classList.remove("btn--loading");
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          },

          _updateCount: function(cart) {
            if (!cart || typeof cart.item_count !== 'number') {
              return;
            }

            var count = cart.item_count;
            var countEls = document.querySelectorAll('.cart-link__bubble-num');
            countEls.forEach(function(el) {
              el.innerText = count;
            });

            var bubbles = document.querySelectorAll('.cart-link__bubble');
            bubbles.forEach(function(bubble) {
              if (count > 0) {
                bubble.classList.add('cart-link__bubble--visible');
              } else {
                bubble.classList.remove('cart-link__bubble--visible');
              }
            });
          }
        });
    
        return cartRemoveSelector;
    })();
    
      theme.UpdatePurchase = (function() {
        function cartUpdatePurchase(el) {
          this.upgradeBtn = el;
          this.init();
        }
      
        cartUpdatePurchase.prototype = Object.assign({}, cartUpdatePurchase.prototype, {
          init: function() {
            this.upgradeBtn.addEventListener('click', function(e) {
              e.preventDefault();
              this.upgradeBtn.innerText = "Upgrading...";
              this.upgradeBtn.setAttribute("disabled", "disabled");
              const sellingId = this.upgradeBtn.dataset.firstSelectedSellingPlanId;
              const lineItemIndex = this.upgradeBtn.dataset.lineItemIndex;
              const qty = parseInt(this.upgradeBtn.dataset.lineItemQuantity);
    
              this._updateCart(lineItemIndex, qty, sellingId);
            }.bind(this));
          },
    
          _updateCart: function(lineItemIndex, qty, sellingId) {
            const data = {
                line: lineItemIndex,
                quantity: qty,
                selling_plan: sellingId
              }
    
            fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => response.json)
            .then(data => {
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          }
        });
    
        return cartUpdatePurchase;
    })();
    
      theme.PurchaseSelector = (function() {
        function cartPurchaseSelector(el) {
          this.purchaseSelector = el;
          this.init();
        }
      
        cartPurchaseSelector.prototype = Object.assign({}, cartPurchaseSelector.prototype, {
          init: function() {
            this.purchaseSelector.addEventListener('change', function(e) {
              e.preventDefault();
    
              const sellingId = parseInt(e.target.value);
              const lineItemIndex = this.purchaseSelector.dataset.lineItemIndex;
              const qty = parseInt(this.purchaseSelector.dataset.lineItemQuantity);
    
              this._updateCart(lineItemIndex, qty, sellingId);
            }.bind(this));
          },
    
          _updateCart: function(lineItemIndex, qty, sellingId) {
            const data = {
                line: lineItemIndex,
                quantity: qty,
                selling_plan: sellingId
              }
    
            this.purchaseSelector.setAttribute("disabled", "disabled");
            fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => response.json)
            .then(data => {
              document.dispatchEvent(new CustomEvent('cart:build'));
            })
          }
        });
    
        return cartPurchaseSelector;
    })();

    if (!document.body.classList.contains('template-cart')) {
        new theme.CartDrawer();
    };

    function initUpsellSlider() {
        new Swiper("[js-upsell-slider]", {
            slidesPerView: 2,
            spaceBetween: 16,
            freeMode: {
                enabled: true,
                sticky: true
            },
            breakpoints: {
                480: {
                    slidesPerView: 3
                }
            }
        });
    };

    initUpsellSlider();
    initUpsellBtn();

    document.addEventListener("cart-upsell:init", function() {
      initUpsellSlider();
      initUpsellBtn();
    });

    function upsellAddToCart() {
        const productId = this.dataset.productId;
        this.classList.add("btn--loading");

        const data = {
            items: [
                {
                    id: productId,
                    quantity: 1
                }
            ]
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((data) => {
            this.classList.remove("btn--loading");
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch((err) => {
            console.error('Upsell add-to-cart failed:', err);
            this.classList.remove("btn--loading");
        })
    }

    function upsellSizeChange() {
        const select = this;
        const item = select.closest('[data-variants]');
        if (!item) return;

        const variants = JSON.parse(item.dataset.variants);
        const selectedId = parseInt(select.value, 10);
        const variant = variants.find(function(v) { return v.id === selectedId; });
        if (!variant) return;

        const btn = item.querySelector('[js-upsell-btn]');
        if (!btn) return;

        btn.dataset.productId = variant.id;

        if (variant.available) {
            btn.removeAttribute('disabled');
            btn.querySelector('span').textContent = 'add –';
        } else {
            btn.setAttribute('disabled', 'disabled');
            btn.querySelector('span').textContent = 'Sold Out';
        }
    }

    function initUpsellBtn() {
        const upsellBtn = document.querySelectorAll("[js-upsell-btn]");
        upsellBtn.forEach( btn => {
            btn.removeEventListener('click', upsellAddToCart);
            btn.addEventListener('click', upsellAddToCart);
        });

        const upsellSelects = document.querySelectorAll("[js-upsell-size]");
        upsellSelects.forEach( select => {
            select.removeEventListener('change', upsellSizeChange);
            select.addEventListener('change', upsellSizeChange);
        });
    }
})();
